"use client";

import { useState } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import ImageLightbox from "./ImageLightbox";

type Testimonial = {
  id: string;
  type: "text" | "image";
  name: string;
  role: string;
  rating?: number;
  content?: string;
  avatarBg?: string;
  images?: string[];
  caption?: string;
};

/**
 * Toàn bộ testimonials.
 * Tự phân trang 3 cards/trang.
 * Anh thêm review mới cứ append vào array này.
 */
const TESTIMONIALS: Testimonial[] = [
  {
    id: "tm-1",
    type: "image",
    name: "Nguyễn Thị Nhung",
    role: "Đỗ Vietinbank 02/2016",
    images: ["/images/testimonials/vietinbank-2016.jpg"],
    caption:
      "Em đã nhận quyết định đi làm vào 19/02/2016 sau khi vượt qua 2 vòng phỏng vấn QHKHDN của VietinBank.",
    rating: 5,
  },
  {
  id: "tm-2",
  type: "image",     // ← đổi sang "image" vì có ảnh
  name: "Trần Hữu Việt - fb.com/viet.tran.313",
  role: "Đỗ Quan hệ khách hàng Vietinbank 2012",
  images: [
    "/images/testimonials/vietinbank-2012-viet-tran.jpg",
    "/images/testimonials/vietinbank-2012-quynh-giang.jpg",
  ],
  caption:           // ← đổi content → caption (vì type="image")
    "Lúc nào nhắn tin gọi điện, chat fb mình cũng được anh Giang rep nhiệt tình. Mình có đăng ký học khóa Online và kết hợp với mua sách ôn thi Vietinbank, sách ôn tín dụng - QHKH và đặc biệt là cuốn 300 câu phỏng vấn tín dụng. Anh viết khá hay, cẩn thận và chi tiết. Mình đã trúng tuyển vào Vietinbank ngay đợt tuyển đầu tiên khi mới ra trường. Mình cảm thấy rất may mắn, cảm ơn anh Giang đã phát hành những cuốn sách hết sức hữu ích thế này với sinh viên chúng mình! Ngoài ra, mình đã giới thiệu với a Giang bạn Quỳnh Giang cùng lớp. Bạn ấy phỏng vấn trượt nhiều tội lắm. Ấy thế mà cũng đậu luôn ngân hàng rồi nè",
  avatarBg: "from-orange-400 to-orange-600",
  rating: 5,
},
  {
    id: "tm-3",
    type: "image",
    name: "Hoàng Quốc Hưng - fb.com/hqh96",
    role: "Đỗ Vietcombank Vĩnh Phúc 2018",
    images: ["/images/testimonials/vietcombank-vinh-phuc-hoang-quoc-hung.jpg"],
    caption:
      "Quyết định chỉ trong khoảng 3 tuần trước khi hết hạn hồ sơ vào VCB đợt tháng 5 năm 2018, mất hơn 1 tuần mày mò các kiến thức từng học và các nguồn thông tin trên mạng, thật sự mình như ngụp lặn trong biển kiến thức ngân hàng. May sao, 1 người bạn từng thi ngân hàng và cũng đang là 1 cán bộ Vietcombank, mình biết đến những ebooks của anh Nguyễn Lê Giang. Mình cũng thấy nhiều bạn đã thành công sau khi đọc sách của anh, mình chủ động liên hệ và được anh tư vấn rất nhiệt tình về kiến thức cần thiết cho vị trí tuyển dụng. Hai tuần còn lại, ngày đi làm, tối về ôn luyện với một chút may mắn, mình cũng đã vượt qua kỳ thi online gồm 2 phần nghiệp vụ và ngoại ngữ với số điểm cũng khá cao. Những cuốn ebooks hết sức bổ ích, cô đọng, sát trọng tâm vị trí thi tuyển. Mình đúc kết ra công thức thành công đó là: Formula = Kiến thức sẵn có + Sách của anh Giang + Chịu khó + Chút may mắn",
    avatarBg: "from-teal-500 to-teal-700",
    rating: 5,
  },
  {
    id: "tm-4",
    type: "image",
    name: "Lê Thị Huyền Trang - fb.com/home.xukas",
    role: "Đỗ Vietinbank Hải Phòng 2015",
    images: ["/images/testimonials/vietinbank-hai-phong-2012-le-thi-huyen-trang-trung-tuyen-giao-dich-vien.jpg"],
    caption:
      "Thật tuyệt vời, nhờ tin tưởng tuyệt đối vào cuốn Cẩm nang ôn thi Giao dịch viên của a Giang, em đã đỗ vị trí Giao dịch viên của ngân hàng Vietinbank như mong muốn. Đề thi Test, các câu giống và tương tự đến 70%. Trước khi phỏng vấn, được chị Trưởng phòng khen thi Test điểm cao nên em càng tự tin. Thật không ngờ, các câu phỏng vấn rất giống phần em ôn nên trả lời rất bình tĩnh và tự tin. Em cảm ơn anh Giang và đội ngũ Giangblog rất nhiều ạ",
    rating: 5,
  },
  {
    id: "tm-5",
    type: "image",
    name: "Phan Thị Thu Trang - SV Cao đẳng Tài chính Hải Quan - fb.com/profile.php?id=100006995523572",
    role: "Đỗ Giao dịch viên LienVietPostBank (nay là LPBank)",
    images: ["/images/testimonials/lienvietpostbank-2015-pham-thi-thu-trang.jpg"],
    caption:
      "Đối với một người mới ra trường không có kinh nghiệm như mình, cầm tấm bằng Cao đẳng trên tay... Đến ngay bản thân cũng không nghĩ mình có thể thi đỗ hai ngân hàng với hai vị trí khác nhau. Trong quá trình tìm tài liệu mình vô tình đọc đc sách của a Giang viết, đc biết a là một tác giả của nhiều đầu sách hay viết về thi tuyển ngân hàng. Mình khá tâm đắc về phần giải thích kèm theo những điều luật trong sách, trong bài test nghiệp vụ mình trả lời đc thêm khá nhiều câu hỏi có liên quan đến nội dung đó... Đặc biệt hơn, cẩm nang giao dịch viên ngân hàng giúp mình ôn thi gỏn gọn chỉ trong thời gian 1,5 ngày kể từ khi nhận đc mail tbao đến ngày thi. Nói là 1,5 ngày chứ còn đi làm nên thời gian rảnh mới ngâm cứu và đọc.",
    avatarBg: "from-orange-400 to-orange-600",
    rating: 5,
  },
  {
    id: "tm-6",
    type: "image",
    name: "Mạnh Dũng",
    role: "Đỗ BIDV 2018",
    images: ["/images/testimonials/bidv-2018-manh-dung.jpg"],
    caption:
      "Thề, mua sách học đi các bạn. Ôn thi VCB mà đỗ cả BIDV luôn mới ghê",
    avatarBg: "from-teal-500 to-teal-700",
    rating: 5,
  },
];

const PAGE_SIZE = 3;

export default function TestimonialsGrid() {
  const [lightboxSrc, setLightboxSrc] = useState<string | null>(null);
  const [page, setPage] = useState(0);

  const totalPages = Math.max(1, Math.ceil(TESTIMONIALS.length / PAGE_SIZE));
  const start = page * PAGE_SIZE;
  const visible = TESTIMONIALS.slice(start, start + PAGE_SIZE);

  return (
    <section className="bg-card rounded-2xl shadow-card p-6 sm:p-8">
      <div className="mb-5">
        <div className="text-xs font-bold uppercase tracking-wider text-orange-600 mb-2">
          Testimonials · Khách hàng
        </div>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-teal-900">
          Khách hàng nói gì về JB
        </h2>
      </div>

      <p className="text-muted-foreground leading-relaxed mb-6">
        Đây là một vài tin nhắn và phản hồi thật từ các bạn đã đỗ vào ngân hàng sau khi sử dụng
        tài liệu JB.com.vn / GiangBLOG. Thông tin cá nhân đã được làm mờ để bảo vệ quyền riêng tư.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {visible.map((t) => (
          <TestimonialCard
            key={t.id}
            testimonial={t}
            onImageClick={(src) => setLightboxSrc(src)}
          />
        ))}
      </div>

      {/* Pagination — chỉ hiện khi có nhiều hơn 1 trang */}
      {totalPages > 1 && (
        <div className="mt-6 pt-6 border-t border-border flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Trang <strong className="text-teal-900">{page + 1}</strong> / {totalPages}
            <span className="hidden sm:inline ml-2 text-xs">
              ({TESTIMONIALS.length} phản hồi)
            </span>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setPage((p) => Math.max(0, p - 1))}
              disabled={page === 0}
              aria-label="Trang trước"
              className="w-10 h-10 rounded-lg border border-border bg-background hover:bg-teal-50 hover:border-teal-300 disabled:opacity-40 disabled:cursor-not-allowed transition-all flex items-center justify-center text-teal-900"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button
              onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
              disabled={page === totalPages - 1}
              aria-label="Trang sau"
              className="w-10 h-10 rounded-lg border border-border bg-background hover:bg-teal-50 hover:border-teal-300 disabled:opacity-40 disabled:cursor-not-allowed transition-all flex items-center justify-center text-teal-900"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      <ImageLightbox
        src={lightboxSrc}
        alt="Phản hồi từ học viên"
        onClose={() => setLightboxSrc(null)}
      />
    </section>
  );
}

function TestimonialCard({
  testimonial: t,
  onImageClick,
}: {
  testimonial: Testimonial;
  onImageClick: (src: string) => void;
}) {
  const initials = t.name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="flex flex-col p-5 rounded-xl bg-gradient-to-br from-background to-teal-50/30 border border-border hover:border-teal-300 hover:shadow-card-md transition-all">
      <div className="flex items-center gap-3 mb-4">
        <div
          className={`w-10 h-10 rounded-full bg-gradient-to-br ${
            t.avatarBg || "from-teal-500 to-teal-700"
          } flex items-center justify-center text-white text-xs font-bold shrink-0`}
        >
          {initials}
        </div>
        <div className="min-w-0">
          <div className="font-semibold text-teal-900 text-sm line-clamp-2 leading-tight">{t.name}</div>
<div className="text-[11px] text-orange-600 font-medium line-clamp-2 leading-tight mt-0.5">{t.role}</div>
        </div>
      </div>

      {t.images && (
        <div className="space-y-3 flex-1">
          <div className="space-y-2">
            {t.images.map((src, idx) => (
              <button
                key={idx}
                onClick={() => onImageClick(src)}
                className="block relative rounded-lg overflow-hidden bg-teal-50 border border-border hover:border-orange-400 transition-colors cursor-zoom-in"
                aria-label="Phóng to ảnh"
              >
                <img
                  src={src}
                  alt={`Tin nhắn từ ${t.name}`}
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </button>
            ))}
          </div>
          {t.caption && (
            <p className="text-xs text-foreground/70 leading-relaxed italic">
              "{t.caption}"
            </p>
          )}
        </div>
      )}

      {t.content && (
        <p className="text-sm text-foreground/80 leading-relaxed italic flex-1">
          "{t.content}"
        </p>
      )}

      {t.rating && (
        <div className="flex gap-0.5 mt-4 pt-4 border-t border-border">
          {Array.from({ length: t.rating }).map((_, i) => (
            <Star key={i} className="w-3.5 h-3.5 fill-orange-400 text-orange-400" />
          ))}
        </div>
      )}
    </div>
  );
}
